import React from 'react';
import { companyInfo, navLinks } from '../data/mock';
import { Mail, Phone, MapPin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center">
                <span className="text-white font-bold text-xl">E</span>
              </div>
              <span className="text-xl font-bold text-white">
                Ed<span className="text-teal-500">Konect</span>
              </span>
            </a>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed">
              {companyInfo.tagline}. Empowering schools across India with smart technology solutions for efficient campus management.
            </p>
            <div className="flex items-center gap-6">
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-slate-400 hover:text-teal-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span className="text-sm">{companyInfo.email}</span>
              </a>
            </div>
            <div className="flex items-center gap-2 text-slate-400 mt-3">
              <Phone className="w-4 h-4" />
              <span className="text-sm">{companyInfo.phone}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-teal-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={companyInfo.appUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-teal-400 transition-colors text-sm"
                >
                  Login to App
                </a>
              </li>
            </ul>
          </div>

          {/* Modules */}
          <div>
            <h4 className="text-white font-semibold mb-6">Modules</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-slate-400 text-sm">Student Information</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Fee Management</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Attendance Tracking</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Academic Reports</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Transport Management</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-slate-500 text-sm">
              &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-slate-600 text-xs mt-1">
              A product of <span className="text-teal-500 font-medium">{companyInfo.owner}</span>
            </p>
          </div>

          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-slate-400 hover:text-teal-400 transition-colors group"
          >
            <span className="text-sm">Back to top</span>
            <div className="w-8 h-8 rounded-full border border-slate-700 flex items-center justify-center group-hover:border-teal-500 transition-colors">
              <ArrowUp className="w-4 h-4" />
            </div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
